import { h, Component } from 'preact';
import { Listing } from '../../../../../types';
import { User } from '../../../../../types';
import { getUserType } from '../../../../utils/listing-utils';

interface ListingEditorPrimaryContactSectionProps {
  listing?: Listing;
  currentUser?: User;
  showContact?: boolean;
}

interface ListingEditorPrimaryContactSectionState {}

export class ListingEditorPrimaryContactSection extends Component<ListingEditorPrimaryContactSectionProps, ListingEditorPrimaryContactSectionState> {
  getContactDetails(listing: Listing, currentUser: User) {
    const isAssigned = Boolean(listing.salesDirectorProfile);
    var userType = getUserType(currentUser, listing);
    var details = {
      director_name: 'Unassigned',
      director_email: '*****',
      director_number: '*****',
      name: '*****',
      email: '*****',
      number: '*****'
    };
    if (['internal_sales_director', 'external_sales_director', 'external_manager'].includes(userType) && isAssigned) {
      details.director_name = listing.salesDirectorName;
      details.director_email = listing.salesDirectorEmail;
      details.director_number = listing.salesDirectorMobile;
    } else if (['external_sales_director', 'external_manager'].includes(userType) && !isAssigned) {
      return details;
    } else {
      details.name = listing.uploaderName;
      details.email = listing.uploaderEmail;
      details.number = listing.uploaderMobile;
    }
    return details;
  }

  render() {

    const { listing, currentUser, showContact } = this.props;
    let contactDetails = this.getContactDetails(listing, currentUser);

    return (
      <div className="container-fluid px-0">
        <hr />
        <strong>Primary Contact</strong>
        <form className="mt-3">

          <div className="hi-input-group">
            <label className="hi-input-group__label">Sales Director</label>
            <input
              disabled
              className="form-control hi-text-input"
              value={contactDetails.director_name}
              placeholder={ listing.salesDirectorName ? '' : 'Partner Broker Network' }
              type="text" />
          </div>

          <div className="form-row mt-3">
            <div className="hi-input-group col-6">
              <label className="hi-input-group__label">Contact Number</label>
              <input
                disabled
                className="form-control hi-text-input"
                value={ contactDetails.director_number }
                placeholder="Contact Name" 
                type="text" />
            </div>

            <div className="hi-input-group col-6">
              <label className="hi-input-group__label">Contact Email</label>
              <input
                disabled
                className="form-control hi-text-input"
                value={ contactDetails.director_number }
                placeholder="Contact Email" 
                type="text" />
            </div>
          </div>

          { showContact &&
          <div className="hi-input-group mt-3">
              <label className="hi-input-group__label">Uploader/Owner</label>
              <input
                disabled
                className="form-control hi-text-input"
                value={ contactDetails.name }
                placeholder="Contact Name" 
                type="text" />
          </div>
          }
          { showContact &&
          <div className="form-row mt-3">
            <div className="hi-input-group col-6">
              <label className="hi-input-group__label">Contact Email</label>
              <input
                disabled
                className="form-control hi-text-input"
                value={ contactDetails.email }
                placeholder="Contact Email" 
                type="text" />
            </div>

            <div className="hi-input-group col-6">
              <label className="hi-input-group__label">Contact Number</label>
              <input
                disabled
                className="form-control hi-text-input"
                value={ contactDetails.number }
                placeholder="Contact Number" 
                type="text" />
            </div>
          </div>
          }
          <div className="hi-input-group col-12 px-0 mt-3">
            <label className="hi-input-group__label">Description</label>
            <textarea 
              disabled
              placeholder="Unit Description"
              className="form-control hi-listing-editor-modal__editor__notes"
              value={ listing.description }>
            </textarea>
          </div>

          { showContact &&
          <div className="hi-input-group col-12 px-0 mt-3">
            <label className="hi-input-group__label">Contact Notes</label>
            <input
              disabled
              className="form-control hi-text-input"
              value={listing.contactNotes}
              placeholder="Contact Notes"
              type="text" />
          </div>
          }
        </form>
      </div>
    )
  }
}